export default "__VITE_ASSET__BK0xTyHq__"